export default function checkURL(value?: string | null) {
  if (!value || /\s/.test(value)) {
    return false
  }

  if ('canParse' in URL && typeof URL.canParse === 'function') {
    return URL.canParse(value) as boolean
  }

  try {
    new URL(value)

    return true
  } catch {
    return false
  }
}
